<div *ngIf="loading; else loaded">Loading...</div>

<ng-template #loaded>
  <div *ngIf="aircraftPerformanceAudits && aircraftPerformanceAudits.length > 0; else noAudits">
    <sd-portal-audit-detail-list
      (nextPage)="onNextPage()"
      [audits]="aircraftPerformanceAudits"
    ></sd-portal-audit-detail-list>
  </div>
  <ng-template #noAudits> No Aircraft Performance audits </ng-template>
</ng-template>
